(function(app) {

    app.constant("riskTolerances",
        [
            { Name: "Conservative", Value: 1 },
            { Name: "Moderately Conservative", Value: 2 },
            { Name: "Moderate", Value: 3 },
            { Name: "Moderately Aggressive", Value: 4 },
            { Name: "Aggressive", Value: 5 }
        ]);

})(window.app); //jshint ignore:line